import { GeneralModel } from ".";

export class AccountingAccount extends GeneralModel {
    public isTransfer: boolean;  
}